import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';
import {
  NEW_SPECIFICATION_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import List from './List';
import New from './New';
import Edit from './Edit';

class Templates extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    params: PropTypes.shape({
      templateID: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static New = checkChanges(New, { message: NEW_SPECIFICATION_PROMPT })
  static Edit = checkChanges(Edit)

  constructor(props) {
    super(props);
    const type = window.location.pathname.includes('quotation_templates') ? 'quotation' : 'print';
    this.state = {
      token: null,
      loading: true,
      data: null,
      type,
    };
  }
  componentDidMount() {
    if (this.props.params.templateID) {
      this.fetchTemplate();
    } else if (this.props.location.pathname.includes('/new/')) {
      this.listTemplates();
    } else {
      this.setLoading(false);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;
    if (nextProps.params.templateID) {
      if (pathname !== this.props.location.pathname) {
        this.fetchTemplate();
      }
    } else if (pathname.includes('/new/')) {
      this.listTemplates();
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchTemplate() {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/templates/${encodeURIComponent(this.props.params.templateID)}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async listTemplates(q = {}) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let type = 'print';
    if (window.location.pathname.includes('quotation_templates')) type = 'quotation';
    const query = Object.assign({
      page: 1,
      templateType: type,
    }, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`/templates/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
        data: this.state.data,
        templateID: this.props.params.templateID,
        type: this.state.type,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

const TranslatedTemplates = withTranslation(namespaces)(Templates);
TranslatedTemplates.List = Templates.List;
TranslatedTemplates.New = Templates.New;
TranslatedTemplates.Edit = Templates.Edit;
export default TranslatedTemplates;



// WEBPACK FOOTER //
// ./src/containers/Templates/Templates.jsx